export type ButtonType =
  | 'primary'
  | 'neutral'
  | 'outline'
  | 'outline-neutral'
  | 'accent'
  | 'bare'
  | 'bare-neutral';
